<script setup lang="ts">
import { useI18n } from 'vue-i18n'

export interface ZhrnutiePageProps {
  /** Token pre autentizáciu requestov pri zobrazovaní tejto stránky v ISe. */
  bearerToken?: boolean
}

const props = defineProps<ZhrnutiePageProps>()
const { t } = useI18n()
</script>

<template>
  <IDSKHeading v-if="!props.bearerToken" as="h1" variant="xl">{{
    t('zoppm.step15.mainHeading')
  }}</IDSKHeading>
  <IDSKHeading v-else as="h1" variant="xl">{{
    t('zoppm.step15.headingFromIs')
  }}</IDSKHeading>
</template>

<style lang="scss"></style>
